module.exports = {"659004001":"军垦路街道","659004002":"青湖路街道","659004003":"人民路街道","659004500":"兵团一零一团","659004501":"兵团一零二团","659004502":"兵团一零三团"}


//////////////////
// WEBPACK FOOTER
// ./src/town/659004.json
// module id = 2936
// module chunks = 0